import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullscreenExit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M768 576V128Q768 102 749.0 83.0Q730 64 704.0 64.0Q678 64 659 83L515 227L183 -105Q173 -115 160.0 -115.0Q147 -115 137 -105L23 9Q13 19 13.0 32.0Q13 45 23 55L355 387L211 531Q192 550 192.0 576.0Q192 602 211.0 621.0Q230 640 256 640H704Q730 640 749.0 621.0Q768 602 768 576ZM1513 1225 1181 893 1325 749Q1344 730 1344.0 704.0Q1344 678 1325.0 659.0Q1306 640 1280 640H832Q806 640 787.0 659.0Q768 678 768 704V1152Q768 1178 787.0 1197.0Q806 1216 832.0 1216.0Q858 1216 877 1197L1021 1053L1353 1385Q1363 1395 1376.0 1395.0Q1389 1395 1399 1385L1513 1271Q1523 1261 1523.0 1248.0Q1523 1235 1513 1225Z"
	})
});
export default SvgFullscreenExit;
